var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { MenubarProgressButton } from './MenubarProgressButton';
import { runtime } from '../../../classes/runtime/Runtime';
import { AvailablePopover } from '../../../components/other/AvailablePopover';
import { FunnelType } from '../../../classes/learnware/LearnwareEnums';
let MenubarProgress_ = class MenubarProgress_ extends React.PureComponent {
    render() {
        const { app } = this.props;
        const { topic, user, menubarProgress } = app;
        if (!topic || !user || !menubarProgress || runtime.isServerRuntime)
            return null;
        if (topic.funnel === FunnelType.Succession)
            return null;
        if (!menubarProgress.isProgressMenuOpen)
            return React.createElement(MenubarProgressButton, { app: app });
        return (React.createElement(AvailablePopover, { content: this.popoverContent, visible: menubarProgress.isProgressMenuOpen, placement: "bottom", trigger: "click", onVisibleChange: action((isVisible) => (menubarProgress.isProgressMenuOpen = isVisible)), mouseEnterDelay: 0, mouseLeaveDelay: 0 },
            React.createElement(MenubarProgressButton, { app: app })));
    }
    get popoverContent() {
        const { app } = this.props;
        const { menubarProgress } = app;
        if (!menubarProgress.isProgressMenuOpen)
            return null;
        if (!runtime.streamedPackages.Lazy)
            return null;
        const { MenubarProgressMenu } = runtime.streamedPackages.Lazy.components;
        return React.createElement(MenubarProgressMenu, { app: app });
    }
};
MenubarProgress_ = __decorate([
    observer
], MenubarProgress_);
export { MenubarProgress_ };
